"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UserProfilePageActions;
(function (UserProfilePageActions) {
    UserProfilePageActions["RecordLoaded"] = "RecordLoaded";
    UserProfilePageActions["Error"] = "Error";
})(UserProfilePageActions || (UserProfilePageActions = {}));
exports.default = UserProfilePageActions;
